import type { ApiClientOptions } from "./client";
import { createApiClient } from "./client";

export interface BalanceResponse {
  plan_credits: number;
  purchased_credits: number;
  purchased_credits_total: number;
  purchased_credits_expires_at: string | null;
  overdraft_credits: number;
  total: number;
  plan: "free" | "pro" | "max";
  plan_credits_monthly: number;
  credits_reset_at: string | null;
}

export interface TransactionResponse {
  id: string;
  amount_credits: number;
  description: string;
  model_api_id: string | null;
  provider: string | null;
  pricing_unit: string | null;
  created_at: string;
  module_type: string | null;
  project_id: string | null;
  project_name: string | null;
  run_id: string | null;
  node_id: string | null;
}

export interface TransactionListResponse {
  items: TransactionResponse[];
  total: number;
  page: number;
  page_size: number;
}

export interface TransactionListParams {
  page?: number;
  page_size?: number;
  project_id?: string;
  module_type?: string;
}

export function createCreditsApi(options: ApiClientOptions) {
  const api = createApiClient(options);

  return {
    getBalance: () => api.get<BalanceResponse>("/api/credits/balance"),
    subscribe: (plan_slug: "pro" | "max", billing: "monthly" | "annual", return_url?: string) =>
      api.post<{ url: string }>("/api/credits/subscribe", {
        plan_slug,
        billing,
        ...(return_url ? { return_url } : {}),
      }),
    portal: () => api.post<{ url: string }>("/api/credits/portal", {}),
    getTransactions: (params: TransactionListParams = {}) => {
      const query = new URLSearchParams();
      if (params.page) query.set("page", String(params.page));
      if (params.page_size) query.set("page_size", String(params.page_size));
      if (params.project_id) query.set("project_id", params.project_id);
      if (params.module_type) query.set("module_type", params.module_type);
      const qs = query.toString();
      return api.get<TransactionListResponse>(
        `/api/credits/transactions${qs ? `?${qs}` : ""}`
      );
    },
  };
}
